export default __webpack_public_path__ + "static/media/books.5412e81b.png";